var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilSupplyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Pencil_Supply_icon_svg__clip0_2002_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.226 186.826L157.938 426.197c-10.187 8.314-11.706 23.313-3.391 33.5l319.161 391.052c8.314 10.187 23.313 11.705 33.5 3.391l293.289-239.371c10.187-8.315 11.705-23.313 3.391-33.501L484.727 190.217c-8.315-10.187-23.313-11.705-33.501-3.391z",
    fill: "#2935D6",
    stroke: "#2935D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.293 166.357L183.005 405.728c-10.187 8.315-11.705 23.313-3.391 33.501L498.775 830.28c8.314 10.187 23.313 11.705 33.5 3.391L825.564 594.3c10.187-8.314 11.705-23.313 3.391-33.5L509.794 169.749c-8.315-10.188-23.313-11.706-33.501-3.392z",
    fill: "#40A9D6",
    stroke: "#4084D6",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.5 529.845c-5.619 0-10.881-2.5-14.44-6.845l-.405-.5c-6.5-7.964-5.31-19.714 2.655-26.214l58.94-48.107a18.715 18.715 0 0111.774-4.203c5.619 0 10.881 2.5 14.44 6.845l.405.5c6.5 7.965 5.31 19.715-2.655 26.215l-58.94 48.107a18.722 18.722 0 01-11.774 4.202z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.024 453.512a9.086 9.086 0 017.059 3.345l.405.5c3.179 3.893 2.595 9.631-1.298 12.81l-58.94 48.107a9.05 9.05 0 01-5.75 2.047 9.086 9.086 0 01-7.06-3.345l-.404-.5c-3.179-3.893-2.596-9.631 1.297-12.809l58.941-48.107a9.051 9.051 0 015.75-2.048zm0-19.048a28.201 28.201 0 00-17.798 6.346l-58.94 48.107c-12.024 9.821-13.822 27.583-4.012 39.607l.405.5a28.045 28.045 0 0021.821 10.357c6.464 0 12.786-2.25 17.798-6.345l58.94-48.107c12.024-9.822 13.822-27.584 4.012-39.608l-.405-.5a28.045 28.045 0 00-21.821-10.357z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.452 592.262c-5.619 0-10.881-2.5-14.44-6.845l-.417-.512c-6.488-7.953-5.297-19.714 2.655-26.203l58.94-48.107a18.722 18.722 0 0111.774-4.202c5.619 0 10.881 2.5 14.441 6.845l.405.5c6.5 7.964 5.309 19.714-2.655 26.214l-58.941 48.108a18.72 18.72 0 01-11.774 4.202h.012z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.964 515.929a9.09 9.09 0 017.06 3.345l.405.5c3.178 3.893 2.595 9.631-1.298 12.809l-58.941 48.108a9.05 9.05 0 01-5.75 2.047 9.089 9.089 0 01-7.059-3.345l-.405-.5c-3.178-3.893-2.595-9.631 1.298-12.81l58.94-48.107a9.052 9.052 0 015.75-2.047zm0-19.048a28.203 28.203 0 00-17.797 6.345l-58.941 48.107c-12.024 9.822-13.821 27.584-4.012 39.608l.405.5a28.045 28.045 0 0021.821 10.357c6.465 0 12.786-2.25 17.798-6.345l58.941-48.108c12.023-9.821 13.821-27.583 4.011-39.607l-.404-.5a28.047 28.047 0 00-21.822-10.357z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.393 654.691c-5.619 0-10.881-2.5-14.441-6.846l-.404-.5c-6.5-7.964-5.31-19.714 2.654-26.214l58.941-48.107a18.72 18.72 0 0111.774-4.202c5.619 0 10.881 2.5 14.44 6.845l.405.5c6.5 7.964 5.309 19.714-2.655 26.214l-58.94 48.107a18.717 18.717 0 01-11.774 4.203z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.917 578.345a9.084 9.084 0 017.059 3.346l.405.5c3.179 3.892 2.595 9.63-1.298 12.809l-58.94 48.107a9.053 9.053 0 01-5.75 2.048 9.09 9.09 0 01-7.06-3.345l-.404-.5c-3.179-3.893-2.596-9.631 1.297-12.81l58.941-48.107a9.051 9.051 0 015.75-2.048zm0-19.047a28.204 28.204 0 00-17.798 6.345l-58.94 48.107c-5.822 4.75-9.453 11.488-10.203 18.976-.762 7.476 1.441 14.81 6.203 20.631l.416.5a28.064 28.064 0 0021.81 10.345c6.464 0 12.785-2.25 17.797-6.345l58.941-48.107c5.821-4.75 9.452-11.488 10.202-18.976.762-7.476-1.44-14.81-6.202-20.631l-.405-.5a28.045 28.045 0 00-21.821-10.357v.012z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.345 717.107c-5.619 0-10.881-2.5-14.44-6.845l-.405-.5c-6.5-7.964-5.31-19.714 2.655-26.214l58.94-48.107a18.717 18.717 0 0111.774-4.203c5.619 0 10.881 2.5 14.44 6.845l.405.5c6.5 7.965 5.31 19.715-2.654 26.215l-58.941 48.107a18.72 18.72 0 01-11.774 4.202z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.857 640.762a9.09 9.09 0 017.06 3.345l.404.5c3.179 3.893 2.596 9.631-1.297 12.81l-58.941 48.107a9.05 9.05 0 01-5.75 2.047 9.083 9.083 0 01-7.059-3.345l-.405-.5c-3.179-3.893-2.595-9.631 1.298-12.809l58.94-48.107a9.053 9.053 0 015.75-2.048zm0-19.048a28.196 28.196 0 00-17.797 6.346l-58.941 48.107c-5.821 4.75-9.452 11.488-10.202 18.976-.762 7.476 1.44 14.809 6.202 20.631l.417.5a28.065 28.065 0 0021.809 10.345c6.465 0 12.786-2.25 17.798-6.345l58.94-48.107c5.822-4.75 9.453-11.488 10.203-18.976.762-7.477-1.441-14.81-6.203-20.631l-.404-.5a28.045 28.045 0 00-21.822-10.358v.012z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.286 779.524c-5.619 0-10.881-2.5-14.441-6.845l-.404-.5c-6.5-7.965-5.31-19.715 2.654-26.215l58.941-48.107a18.72 18.72 0 0111.774-4.202c5.619 0 10.881 2.5 14.44 6.845l.405.5c6.5 7.964 5.309 19.714-2.655 26.214l-58.94 48.107a18.717 18.717 0 01-11.774 4.203z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.81 703.191a9.086 9.086 0 017.059 3.345l.405.5c3.178 3.893 2.595 9.631-1.298 12.809l-58.94 48.107a9.053 9.053 0 01-5.75 2.048 9.09 9.09 0 01-7.06-3.345l-.405-.5c-3.178-3.893-2.595-9.631 1.298-12.81l58.941-48.107a9.05 9.05 0 015.75-2.047zm0-19.048a28.204 28.204 0 00-17.798 6.345l-58.941 48.107c-5.821 4.75-9.452 11.5-10.202 18.977-.762 7.476 1.441 14.809 6.202 20.63l.405.5a28.045 28.045 0 0021.822 10.358c6.464 0 12.785-2.25 17.797-6.346l58.941-48.107c5.821-4.75 9.452-11.488 10.202-18.976.762-7.476-1.44-14.809-6.202-20.631l-.405-.5a28.066 28.066 0 00-21.81-10.345l-.011-.012z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.238 841.94c-5.619 0-10.881-2.5-14.44-6.845l-.417-.512c-6.488-7.952-5.298-19.714 2.655-26.202l58.94-48.107a18.717 18.717 0 0111.774-4.203c5.619 0 10.881 2.5 14.44 6.846l.405.5c6.5 7.964 5.31 19.714-2.655 26.214L439 837.738a18.714 18.714 0 01-11.774 4.202h.012z",
    fill: "#CAE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.75 765.607a9.086 9.086 0 017.059 3.345l.405.5c3.179 3.893 2.595 9.631-1.297 12.81l-58.941 48.107a9.051 9.051 0 01-5.75 2.048 9.084 9.084 0 01-7.059-3.346l-.405-.5c-3.179-3.892-2.595-9.631 1.297-12.809L480 767.655a9.051 9.051 0 015.75-2.048zm0-19.047a28.206 28.206 0 00-17.798 6.345l-58.94 48.107c-5.822 4.75-9.453 11.5-10.203 18.976-.761 7.476 1.441 14.81 6.203 20.631l.405.5a28.065 28.065 0 0021.809 10.345c6.464 0 12.786-2.25 17.798-6.345l58.94-48.107c5.822-4.75 9.453-11.488 10.203-18.976.762-7.476-1.441-14.81-6.203-20.631l-.405-.5c-5.369-6.584-13.321-10.357-21.821-10.357l.012.012z",
    fill: "#95C2C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.452 294.75h63.905v370.56c0 7.083-5.75 12.821-12.821 12.821h-38.25c-7.084 0-12.822-5.75-12.822-12.821V294.75h-.012z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.262 294.75h63.905v370.56c0 7.083-5.75 12.821-12.822 12.821h-38.25c-7.083 0-12.821-5.75-12.821-12.821V294.75h-.012z",
    fill: "#E3FCFF",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.452 294.75h63.905l-26.928-70.893c-1.667-4.405-8.37-4.405-10.048 0l-26.929 70.893zM606.262 294.75h63.905l-26.929-70.893c-1.667-4.405-8.369-4.405-10.048 0l-26.928 70.893z",
    fill: "#F9B485",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.107 244.072l-7.678-20.227c-1.667-4.404-8.369-4.404-10.048 0l-7.679 20.227h25.405z",
    fill: "#FED425",
    stroke: "#FED425",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.917 244.072l-7.679-20.227c-1.667-4.404-8.369-4.404-10.048 0l-7.678 20.227h25.405z",
    fill: "#95C2C7",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.357 294.75h63.905v370.56c0 7.083-5.75 12.821-12.822 12.821h-38.25c-7.083 0-12.821-5.75-12.821-12.821V294.75h-.012z",
    fill: "#2A848E",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.357 294.75h63.905l-26.929-70.893c-1.666-4.405-8.369-4.405-10.047 0l-26.929 70.893z",
    fill: "#F9B485",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.012 244.072l-7.679-20.227c-1.666-4.404-8.369-4.404-10.047 0l-7.679 20.227h25.405z",
    fill: "#2A848E",
    stroke: "#2A848E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.381 555.441c26.298 18.773 62.821-.036 62.821-32.346V413.119c0-32.309-36.523-51.119-62.821-32.345l-40.786 29.107c-39.976 28.524-39.976 87.917 0 116.452l40.786 29.108zM483.238 555.441c-26.298 18.773-62.821-.036-62.821-32.346V413.119c0-32.309 36.523-51.119 62.821-32.345l40.786 29.107c39.976 28.524 39.976 87.917 0 116.452l-40.786 29.108z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.69 467.345h57.774M616.619 467.345h57.774",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.083 504.179h32.429c10.973 0 19.869-8.896 19.869-19.869v-32.429c0-10.973-8.896-19.869-19.869-19.869h-32.429c-10.973 0-19.869 8.896-19.869 19.869v32.429c0 10.973 8.896 19.869 19.869 19.869z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeWidth: 16,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Pencil_Supply_icon_svg__clip0_2002_410"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSupplyIcon);
export default ForwardRef;